import { useCallback, useContext, useState } from 'react'
import { AuthContext } from '../context/AuthContext'

export function useAPI() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const requestError = {}
  const { token } = useContext(AuthContext)
  const APIRequest = useCallback(
    async (request, data = null, options) => {
      let headers = options?.withoutToken ? {} : { Authorization: `Bearer ${token?.token}` }
	  
      try {
        if (data) {
          data = JSON.stringify(data)
          headers['Content-Type'] = 'application/json'
        }
        setLoading(!options?.disableLoading)

        const response = await fetch(process.env.REACT_APP_BASE_URL + request.api, {
          method: request.method,
          body: data,
          headers
        })
        const body = await response.json()
        const status = await response.status
        const message = await body?.message
        setLoading(false)
        return { body, status, message }
      } catch (e) {
        setLoading(false)
        setError(e.message)
        return { status: e }
      }
    }, [])


  const clearError = useCallback(() => setError(null), [])

  return { loading, APIRequest, requestError, error, clearError }
}

